module.exports = __webpack_public_path__ + "static/media/nutrivision.b8fa23bd.jpg";